const styles = (theme) => ({
  root: {
    cursor: "none !important",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: "-1px",
    position: "relative",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1150)]: {
      justifyContent: "center",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + 900)]: {
      flexDirection: "column",
      padding: "0 1rem",
      paddingTop: "80px",
    },
  },

	
  imgWrap: {
  	marginTop: "-50px",
    cursor: "none !important",
    flexBasis: "auto",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1150)]: {
      transform: "scale(0.8)",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + 900)]: {
      order: 1,
      marginTop: "30px",
      marginBottom: "20px",
      transform: "scale(1)",
    },
  },
  textWrap: {
    cursor: "none !important",
    flexBasis: "50%",
    width: "100%",
    paddingLeft: "50px",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1150)]: {
      paddingLeft: 0,
      paddingRight: "2rem",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + 900)]: {
      order: 0,
    },
  },
  img: {
    cursor: "none !important",
    marginBottom: "-4px",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1250)]: {
      width: "100%",
    },
  },
  h1: {
    cursor: "none !important",
    fontFamily: "Montserrat",
    fontSize: "36px",
    lineHeight: "43.2px",
    letterSpacing: "0.01em",
    color: "black",
    display: "table",
    maxWidth: "20ch",
    margin: 0,
    fontWeight: "700",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1150)]: {
      maxWidth: "100%",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + 900)]: {
      fontSize: "24px",
      lineHeight: "29px",
    },
  },
  p: {
    cursor: "none !important",
    fontFamily: "Aktiv Grotesk",
    color: "black",
    fontSize: "1rem",
    display: "table",
    fontWeight: "400",
    lineHeight: "22.5px",
    letterSpacing: "0.01em",
    margin: 0,
    marginTop: "20px",
    maxWidth: "50ch",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1150)]: {
      maxWidth: "100%",
    },
  },
  caption: {
    cursor: "none !important",
    fontFamily: "Aktiv Grotesk",
    color: "black",
    fontSize: "14px",
    display: "block",
    fontWeight: "400",
    lineHeight: "22.5px",
    letterSpacing: "0.01em",
    margin: 0,
    marginTop: "15px",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1150)]: {
      maxWidth: "100%",
    },
  },
});

export default styles;